import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../../../enums';

const Component = () => import('./BrandViews.vue');

export default [
  // Route with menuId
  {
    path: buildChildURL(
      GlobalMenuGroupsRoutePathNames.MENUS,
      GlobalMenuGroupsRoutePathNames.MENU_ID,
    ),
    name: GlobalMenuGroupsRouteNames.BRAND_MENU,
    component: Component,
  },
  // Route without menuId
  {
    path: buildChildURL(GlobalMenuGroupsRoutePathNames.MENUS),
    name: GlobalMenuGroupsRouteNames.BRAND_MENUS,
    component: Component,
  },
] as RouteRecordRaw[];
